const RichRelevanceBaseInstrumentationController = require('./rr-base-instrumentation-controller');

class RichRelevanceMypageInstrumentationController extends RichRelevanceBaseInstrumentationController {
    constructor($scope, $window, featureService, richRelevanceService) {
        super($scope, $window, featureService, richRelevanceService);
        this.richRelevanceService = richRelevanceService;
        this.$window = $window;
    }

    sendInstrumentation() {
        this.richRelevanceService.getInformation()
            .then(() => {
                this.$window.R3_PERSONAL = new this.$window.r3_personal(); // eslint-disable-line new-cap
                this.$window.rr_flush_onload();

                this.$window.r3();
            });
    }
}

const richRelevanceMypageInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', RichRelevanceMypageInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@',
    },
};

module.exports = {
    RichRelevanceMypageInstrumentationController,
    richRelevanceMypageInstrumentationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/richrelevance/instrumentation/rr-mypage-instrumentation.component.js